// extracted by mini-css-extract-plugin
export var completionBody = "_dc-2";
export var completionCard = "_dc-0";
export var completionFooter = "_dc-3";
export var completionTitle = "_dc-1";